import { RichTextEditor as MantineRichTextEditor, RichTextEditorContentProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";

/**
 * Content wrapper. Applies EdgeTier ProseMirror styles via className so they reach the rendered surface even if the
 * parent's compound `classNames.content` is dropped on the way down.
 */
export const Content: FunctionComponent<RichTextEditorContentProps> = ({ className, ...other }) => (
    <MantineRichTextEditor.Content className={clsx(styles["content"], className)} {...other} />
);

Content.displayName = "RichTextEditor.Content";
